import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import BOSupplierListModal from "../components/boSupplierListModal";
import BOItemListModalPr from "../components/boItemListModalPr";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const AddPr = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [priorNo, setPriorNo] = useState('');
  const [formData, setFormData] = useState({ indentNo: "", remarks: "", department: "" });
  const [dept, setDept] = useState([]);
  const [showLifeDetail, setShowLifeDetail] = useState(false);
  const navigate = useNavigate();

  const canEntry  = hasPermission("Branch office Requisition", "entry");


  useEffect(() => {
  const fetchPriorNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bo_no?branch=${branch}`);
      if (response.data.priorPrNo) {
        const newPrNo = parseInt(response.data.priorPrNo, 10) || 0;
        setPriorNo(newPrNo.toString());
        setFormData(prevState => ({ ...prevState, newPriorNo: newPrNo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPriorNo();
}, [branch]);

useEffect(() => {
    const fetchDept = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bo_dept?branch=${branch}`);
        setDept(response.data.dept || []);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchDept();
  }, [branch]);


  const handleSelectItem = (item) => {
    setSelectedItems((prevItems) => [
      ...prevItems,
      { ...item, vcode: "", vnumber: "", qty: "", duedate: "" },
    ]);
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRowChange = (index, field, value) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleVehicleSelect = (supplierMaster_code, supplierMaster_name) => {
    if (!supplierMaster_code || !supplierMaster_name) {
      console.error("Supplier selection error: Missing supplier code or name");
      return;
    }
  
    // Update formData with the selected supplier
    setFormData((prevData) => ({
      ...prevData,
      supplierCode: supplierMaster_code,
      supplierName: supplierMaster_name,
    }));
  
    setShowVehicleModal(false);
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  // Function to submit the form data
  const handleSubmit = async (e) => {
    e.preventDefault();

     if (!formData.supplierCode || !formData.supplierCode.trim()) {
        Swal.fire("Error", "Please select Supplier Code", "error");
        return;
    }

    // ✅ Check Department
    if (!formData.department || !formData.department.trim()) {
        Swal.fire("Error", "Please select Department", "error");
        return;
    }

    // ✅ Check HM
    if (!formData.hm || !formData.hm.trim()) {
        Swal.fire("Error", "Please enter Head Meterial", "error");
        return;
    }

    // ✅ Check HOD
    if (!formData.hod || !formData.hod.trim()) {
        Swal.fire("Error", "Please enter HOD", "error");
        return;
    }

    // ✅ Check Items
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

    // ✅ Validate each item
  for (let i = 0; i < selectedItems.length; i++) {
    const item = selectedItems[i];

    if (!item.qty || isNaN(item.qty) || item.qty <= 0) {
        Swal.fire("Error", `Please enter a valid Quantity for item #${i + 1}`, "error");
        return;
    }

    // ✅ Due Date validation - must be today's date only
    if (!item.duedate || isNaN(new Date(item.duedate).getTime())) {
    Swal.fire("Error", `Please enter a valid Due Date for item #${i + 1}`, "error");
    return;
} else {
    const enteredDate = new Date(item.duedate);
    const today = new Date();

    // normalize both to yyyy-mm-dd (ignore time part)
    const enteredStr = enteredDate.toISOString().split("T")[0];
    const todayStr = today.toISOString().split("T")[0];

    if (enteredStr < todayStr) {
        Swal.fire(
            "Error",
            `Due Date for item #${i + 1} cannot be in the past. It should be today (${todayStr}) or a future date.`,
            "error"
        );
        return;
    }
}

    // if (!item.lifetime || isNaN(item.lifetime) || item.lifetime <= 0) {
    //     Swal.fire("Error", `Please enter a valid Lifetime for item #${i + 1}`, "error");
    //     return;
    // }
}

    // ✅ If all validations pass → Build Payload
    const payload = {
        branch: branch,
        user: userId,
        priorNo: formData.newPriorNo,
        supplierCode: formData.supplierCode,
        hod: formData.hod,
        indentNo: fld_purnumber,
        dept: formData.department,
        hm: formData.hm,
        remarks: formData.remarks,
        items: selectedItems.map((item) => ({
            itemCode: item.itemmaster_code,
            itemName: item.itemmaster_name,
            itemUom: item.itemmaster_uom,
            qty: item.qty,
            duedate: item.duedate,
            price: item.supplierWIdetail_price,
            lifetime: item.lifetime,
        })),
    };

    try {
        Swal.fire({
            title: "Submitting...",
            text: "Please wait while we process your request.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        const response = await axios.post(
            "https://rfs2.infraconsoft.net.in/api/bo_insert",
            payload
        );

        Swal.fire("Success", "Branch Office Store Req added successfully", "success");
        setSelectedItems([]);
        navigate('/inventory/mis_prview');

    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
              <h2 className="add-txt">Add Branch Office Requisition</h2>
              <Link to='/inventory/mis_prview'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
              </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Req No :</label>
                <input type="text" name="indentNo" value={formData.newPriorNo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs"value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="supplier" value={formData.supplierCode || ""} readOnly onClick={() => setShowVehicleModal(true)} placeholder="Select Supplier"/>
              </div>

              <div className="form-group">
                <label>Supplier Name:</label>
                <input type="text" name="supplierName" value={formData.supplierName || ""} readOnly />
              </div>
            </div>



            <div className="form-row">
              <div className="form-group">
                <label>Type :</label>
                <input type="text" name="remarks" value="Branch Office" onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Department :</label>
                <select name="department" value={formData.department} onChange={handleChange}>
                  <option value="">-- Select Department --</option>
                  {dept.map((item, index) => (
                    <option key={index} value={item.departmentmaster_code}>
                      {item.departmentmaster_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" name="hod" value={formData.hod} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>Head Meterial :</label>
                <input type="text" name="hm" value={formData.hm} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>

            <div className="flex_buttons">
  <button
    type="button"
    className="button button-add"
    onClick={() => {
      if (!formData.supplierCode) {
        Swal.fire("Warning", "Please select supplier first!", "warning");
        return;
      }
      setShowModal(true);
    }}
  >
    Add Item
  </button>
</div>


            {/* <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div> */}

            <div className="content-table">
              <table>
                <thead>
  <tr>
    <th>S.No</th>
    <th>Item Code</th>
    <th>Part No</th>
    <th>Item Name</th>
    <th>UOM</th>
    <th>Price</th>
    <th>Qty</th>
    <th>Due Date</th>

    {/* Life Detail header only if enabled */}
    {showLifeDetail && (
      <th style={{ textAlign: "center" }}>
        Life Detail
      </th>
    )}

    <th>Remove</th>

    {/* Eye toggle column */}
    <th>
      <button
        type="button"
        onClick={() => setShowLifeDetail(!showLifeDetail)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
        }}
      >
        {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </th>
  </tr>
</thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemmaster_code}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td>{item.itemmaster_price}</td>
                        <td><input
                            type="number"
                            value={item.qty}
                            onChange={(e) => handleRowChange(index, "qty", e.target.value)}
                          /></td>
                        <td>
                          <input
                            type="date"
                            value={item.duedate}
                            onChange={(e) => handleRowChange(index, "duedate", e.target.value)}
                          />
                        </td>
                        {showLifeDetail && (
                  <td>
                          <input
                            type="number"
                            value={item.lifetime}
                            onChange={(e) => handleRowChange(index, "lifetime", e.target.value)}
                          />
                        </td>
                )}
                        
                        <td className="del">
                          <i className="fa-solid fa-trash-can" onClick={() => handleDeleteRow(index)}></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>
      <BOItemListModalPr showModal={showModal} closeModal={() => setShowModal(false)} onSelectItem={handleSelectItem} branch={branch} supplierCode={formData.supplierCode} />
      <BOSupplierListModal showModal={showVehicleModal} closeModal={() => setShowVehicleModal(false)} onSelectVehicle={handleVehicleSelect} branch={branch} />
    </div>
  );
};

export default AddPr;
